import { useEffect, useMemo, useState } from "react";
import intl from "react-intl-universal";
import {
  ScreenGreeting,
  TransfersAreaSkeleton,
  TransfersList,
  TransfersShortcutMenu,
} from "../../../Components/Molecules";
import { TransfersFilterBar } from "./TransfersFilterBar";
import { DateAmountSubAccountApiFilterObj } from "../../../Components/Molecules/GridHistory/filterTypes";
import { applyDateAmountSubAccountClientFilters } from "../../../Components/Molecules/GridHistory/dateAmountSubAccountFilters";
import { useTransfersData } from "../../../Hooks";
import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";
import { useFilter } from "../../../Hooks/useFilter";
import { InternalTransferModal } from "./InternalTransferModal";
import {
  filtersFromTransfersFilterObj,
  transfersFilterObjFromFilters,
} from "./transfersFilters";

const TRANSFERS_PATH = "/transferencia";
const EMPTY_SUB_ACCOUNTS = [];

export const Transfers = () => {
  const history = useHistory();
  const location = useLocation();
  const parsedQS = qs.parse(location.search.replace("?", ""));
  const [page, setPage] = useState(1);
  const [transferModal, setTransferModal] = useState(false);
  const [filters, setFilters] = useState(null);
  const {
    state: transfersData,
    handleGET: fetchTransfersGET,
    loading,
  } = useTransfersData();

  const { getFilterObj, handleApplyFilters } = useFilter();
  const transfersFilterObj = getFilterObj("transfers") as DateAmountSubAccountApiFilterObj;

  useEffect(() => {
    setFilters(filtersFromTransfersFilterObj(transfersFilterObj));
  }, [
    transfersFilterObj.start_date,
    transfersFilterObj.end_date,
    transfersFilterObj.start_amount,
    transfersFilterObj.end_amount,
    transfersFilterObj.sub_account_id,
  ]);

  const handleSetToFirstPage = () => {
    setPage(1);
  };

  const openInternalTransfer = () => {
    setTransferModal(true);
  };

  useEffect(() => {
    const queryParameters = {
      is_paged_result: true,
      page: page,
      page_size: 15,
      ...transfersFilterObj,
    };
    fetchTransfersGET({ ...queryParameters });
  }, [transfersFilterObj, page]);

  useEffect(() => {
    if (String(parsedQS.newTransfer) === "true") {
      setTransferModal(true);
      history.replace(TRANSFERS_PATH);
    }
    // Only react to the landing URL (e.g. home quick action ?newTransfer=true).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const transferItems = useMemo(
    () => applyDateAmountSubAccountClientFilters(
      Array.isArray(transfersData) ? transfersData : [],
      filters ?? {},
    ),
    [transfersData, filters],
  );

  const handleFiltersChange = (nextFilters) => {
    setFilters(nextFilters);
    handleSetToFirstPage();
    handleApplyFilters("transfers", transfersFilterObjFromFilters(nextFilters));
  };

  const hasItems = transferItems.length > 0;
  const isInitialLoading = (loading.GET && !hasItems) || filters === null;

  return (
    <>
      <div className="w-full">
        <ScreenGreeting title="Transferências" />

        <TransfersShortcutMenu onOpenInternalTransfer={openInternalTransfer} />

        {isInitialLoading ? (
          <TransfersAreaSkeleton />
        ) : (
          <section>
            <h2 className="mb-3 text-sm font-bold text-brand-dark">{intl.get("transfer.history")}</h2>

            <div className="mb-4">
              <TransfersFilterBar
                filters={filters}
                onFiltersChange={handleFiltersChange}
                filteredItems={transferItems}
                subAccounts={EMPTY_SUB_ACCOUNTS}
              />
            </div>

            <div className="app-card w-full overflow-hidden">
              <TransfersList itens={transferItems} loading={loading.GET} />
            </div>
          </section>
        )}
      </div>

      <InternalTransferModal
        open={transferModal}
        onClose={() => setTransferModal(false)}
      />
    </>
  );
};
